<template>

    <div
        :class="{
            'border-b': accordion,
            'px-5': spacing ? spacing.horizontal : true,
            'py-3': spacing ? spacing.vertical : true,
         }"
    >

        <div v-if="!accordion">
            <slot name="label"></slot>
            <slot name="content"></slot>
        </div>

        <template v-else>
            <div class="flex items-center py-2 cursor-pointer"
                 @click="isOpen = !isOpen"
                 :class="{
                    'text-gray-600': isOpen,
                    'text-gray-500': !isOpen
                }"
            >
                <slot name="label" />

                <div class="ml-auto">
                    <svg v-show="!isOpen" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>

                    <svg v-show="isOpen" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                    </svg>
                </div>
            </div>

            <transition
                enter-active-class="transition duration-100 ease-out transform"
                enter-class="scale-95 opacity-0"
                enter-to-class="scale-100 opacity-100"
                leave-active-class="transition duration-75 ease-in transform"
                leave-class="scale-100 opacity-100"
                leave-to-class="scale-95 opacity-0"
            >

                <div class="mt-1 mb-3" v-show="isOpen">

                    <slot name="content"></slot>
                    <slot name="error"></slot>

                </div>
            </transition>
        </template>

    </div>

</template>

<script>

export default {

    props: {

        spacing: {
            type: Object,

            horizontal: {
                type: Boolean,
                default: true
            },
            vertical: {
                type: Boolean,
                default: true
            }
        },

        accordion: {
            type: Boolean,
            default: true
        },

        open: {
            type: Boolean,
            default: null
        },

    },

    data() {
        return {
            isOpen: this.open || false,
        }
    },

}

</script>
